import React from 'react';
import PropTypes from 'prop-types';
import GarageViewTabContent from 'commons-garage/components/Garage/GarageViewTabContent.jsx';
import { Quote } from '@sm360/widget-commons-vehicle';

import 'commons-garage/components/Garage/Garage.scss';

const GarageView = ({
    dataTest,
    isNewEnabled,
    isUsedEnabled,
    usedUrl,
    timeSaved,
    tradeInAmount,
    isReservationMode,
    tradeInTaxCredits,
    deleteQuote,
    quotes,
}) => {
    return (
        <div className="widget-garage" data-test={dataTest}>
            <div className="GarageView sr-garage">
                <div className="GarageView-button-opening">
                    <GarageViewTabContent
                        isNewEnabled={isNewEnabled}
                        isUsedEnabled={isUsedEnabled}
                        usedUrl={usedUrl}
                        timeSaved={timeSaved}
                        tradeInAmount={tradeInAmount}
                        isReservationMode={isReservationMode}
                        tradeInTaxCredits={tradeInTaxCredits}
                        deleteQuote={deleteQuote}
                        quotes={quotes}
                    />
                </div>
            </div>
        </div>
    );
};

GarageView.defaultProps = {
    isReservationMode: false,
    quotes: [],
};

GarageView.propTypes = {
    dataTest: PropTypes.string.isRequired,
    isNewEnabled: PropTypes.bool.isRequired,
    isUsedEnabled: PropTypes.bool.isRequired,
    usedUrl: PropTypes.string.isRequired,
    tradeInAmount: PropTypes.number.isRequired,
    timeSaved: PropTypes.number,
    isReservationMode: PropTypes.bool,
    tradeInTaxCredits: PropTypes.number.isRequired,
    deleteQuote: PropTypes.func.isRequired,
    quotes: PropTypes.arrayOf(PropTypes.instanceOf(Quote.QuoteModelV25)),
};

GarageView.displayName = 'GarageView';

export default GarageView;
